import { useState } from 'react';
import { assetUrl } from '../api/assets';

/** Decorative screen art behind opaque bone panels (Pocket Diorama). Same stacking model as
 *  `.habitat-scene-bg` — never the surface under body text.
 *
 *  <p>A MISSING BACKDROP RENDERS NOTHING, rather than a broken image. `alt=""` alone does not do
 *  this: Chrome still paints its broken-image placeholder for a failed load, which showed up as a
 *  torn-page glyph in the corner of the shop the moment that screen referenced a `bd_shop_default`
 *  row the art agent has not delivered yet. Every other caller's asset exists, so this was latent
 *  everywhere until a screen was wired ahead of its art — which is the normal order here, since
 *  backdrop rows are hand-maintained and land with the file. Unmounting on error degrades the
 *  screen to its plain ground, which is exactly what it looked like before the backdrop was
 *  wired. */
export function ScreenBackdrop({ id, ambient = false }: { id: string; ambient?: boolean }) {
  const [failed, setFailed] = useState(false);
  if (failed) return null;
  /* The ambient probe (spec §8) is opt-in per call site AND behind a build flag: this component
     has 12 callers, and animating all of them would be the rollout D4 explicitly withheld. */
  const drift = ambient && import.meta.env.VITE_AMBIENT_BACKDROP ? ' backdrop-drift' : '';
  return (
    <img
      className={`screen-backdrop${drift}`}
      src={assetUrl(id)}
      alt=""
      width={1024}
      height={1024}
      onError={() => setFailed(true)}
    />
  );
}
